import {useEffect, useState} from "react";
import UserTable from "../components/userTable";
import ManagerTable from "../components/managerTable";
import Triggers from "../components/triggers";
import {GlobalContext} from "../utils/context";

const Main = () => {
	const [users, setUsers] = useState([]);
	const [managers, setManagers] = useState([]);

	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedManager, setSelectedManager] = useState(null);

	const [reload, _reload] = useState(0);

	useEffect(() => {
		window.reload = ()=>_reload(reload+1);
	}, [reload])

	useEffect(()=>{
		window.reqServer("/admin/users", "get", {}, (users)=>{
			window.reqServer("/admin/managers", "get", {}, (managers)=>{
				setUsers(users.map(u =>({...u, managers: managers.filter(m=>m.owner===u._id).length})));
				setManagers(managers.map(m => ({...m, userEmail: users.find(u=>u._id===m.owner)?.email})));
			});
		});
	}, [reload])

	useEffect(()=>{
		setSelectedManager(null)
	},[selectedUser])

	const logout = () => {
		localStorage.clear();
		window.location.reload();
	}

	return <GlobalContext.Provider value={{users , managers, reload }}>
		<div className="App">
			<h1>Notifier Admin Console</h1>
			<h5>user count: {users.length}</h5>
			<UserTable selectedUser={selectedUser} setSelectedUser={setSelectedUser}/>
			<div className="flex-row">
				<ManagerTable selectedUser={selectedUser} selectedManager={selectedManager} setSelectedManager={setSelectedManager}/>
				<Triggers selectedManager={selectedManager} selectedUser={selectedUser}/>
			</div>
			<button onClick={logout} className="btn1" style={{marginTop: 30}}><span>Logout</span></button>
		</div>
	</GlobalContext.Provider>
}

export default Main;